import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import AskAndGrow from "../../Assests/Images/askandgrow.png";
import Scheduler from "../../Assests/Images/Scheduler.jpeg";
import Hershield from "../../Assests/Images/hershield.png";

function Section4() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  const projects = [
    {
      title: "Ask & Grow",
      description:
        "A community-driven platform for students to discover opportunities, ask questions, and share knowledge.",
      details: [
        "Developed a seamless user interface with over 10,000 lines of code, and implemented a robust system for user authentication using JWT token generation and password hashing with bcrypt.",
        "Devised a robust system for user authentication and engagement, leading to a 20% increase in user interaction.",
      ],
      image: AskAndGrow,
      link: "https://master--adorable-trifle-92330c.netlify.app/",
    },
    {
      title: "HerShield",
      description:
        "A comprehensive platform for incident reporting, legal aid access, and supportive community engagement.",
      details: [
        "Led a team to develop a comprehensive women’s safety web portal with real-time geolocation-based SOS mode.",
        "Innovated a legal advisor chatbot (Sakhi) using OpenAI, achieving 95% accuracy in responses.",
      ],
      image: Hershield,
      link: "#",
    },
    {
      title: "Scheduler",
      description:
        "Enhancing Google Meet and Calendar management with automated scheduling, rescheduling, and slot booking.",
      details: [
        "Engineered a backend system for scheduling meetings, with Google OAuth for user authentication.",
        "Enhanced app functionality and user experience through Google Calendar integration.",
      ],
      image: Scheduler,
      link: "https://github.com/K-u-n-a-l-c/Scheduler",
    },
  ];

  return (
    <section
      style={{
        marginTop: "100px",
        padding: isSmallScreen ? "3rem 1.5rem" : "6rem 2.5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ textAlign: "center", width: "90%" }}>
        <h1
          style={{
            fontFamily: "Font1",
            fontWeight: "800",
            fontSize: isSmallScreen ? "1.5rem" : "2rem",
            marginBottom: "1.5rem",
            letterSpacing: "1px",
            textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.1px",
            color: "#141c3a",
          }}
        >
          My Recent Projects
        </h1>
        <h2
          style={{
            fontFamily: "Font2",
            fontSize: isSmallScreen ? "18px" : "20px",
            marginBottom: "24px",
            fontWeight: 400,
            color: "#141c3a",
          }}
        >
          Here are a few past projects I've worked on.
        </h2>
        <div style={{ paddingTop: isSmallScreen ? "2rem" : "4rem" }}>
          <div
            style={{
              border: isSmallScreen ? "" : "1px solid #aeaeae",
              borderRadius: isSmallScreen ? "" : "2%",
            }}
          >
            {projects.map((project, index) => (
              <div
                key={index}
                style={{
                  border: index >= 2 ? "" : "1px solid #aeaeae",
                  borderWidth: index >= 2 ? "" : "0 0 1px",
                  marginBottom: isSmallScreen ? "1.5rem" : "20px",
                  display: "flex",
                  flexDirection: isSmallScreen ? "column" : "row",
                }}
              >
                <div
                  style={{
                    width: isSmallScreen ? "" : "40%",
                    padding: isSmallScreen ? "15px" : "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                    borderRadius: "30px",
                  }}
                >
                  <img
                    width={isSmallScreen ? "200px" : "200px"}
                    src={project.image}
                    alt={project.title}
                  />
                </div>
                <div
                  style={{
                    width: isSmallScreen ? "" : "60%",
                    padding: isSmallScreen ? "15px" : "30px",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: isSmallScreen ? "center" : "left",
                  }}
                >
                  {!isSmallScreen && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: 800,
                          fontFamily: "Font1",
                          fontSize: isSmallScreen ? "24px" : "28px",
                          marginBottom: "15px",
                        }}
                      >
                        {project.title}
                      </h1>
                      <Button
                        size="small"
                        startIcon={<OpenInNewIcon />}
                        sx={{
                          color: "#0068d1",
                          backgroundColor: "#ebf5ff",
                          p: "5px 12px",
                        }}
                        onClick={() => window.open(project.link, "_blank")}
                      >
                        View Project
                      </Button>
                    </div>
                  )}
                  <h2
                    style={{
                      margin: 0,
                      fontWeight: 400,
                      fontFamily: "Font2",
                      fontSize: isSmallScreen ? "15px" : "17px",
                      color: "#424242",
                    }}
                  >
                    {project.description}
                  </h2>
                  <ul
                    style={{
                      listStyleType: "initial",
                      marginTop: "30px",
                      paddingLeft: isSmallScreen ? "1rem" : "2rem",
                    }}
                  >
                    {project.details.map((detail, detailIndex) => (
                      <>
                        <li
                          key={detailIndex}
                          style={{
                            textAlign: "left",
                            lineHeight: 1.5,
                            marginBottom: "10px",
                          }}
                        >
                          {detail}
                        </li>
                        <br />
                      </>
                    ))}
                  </ul>
                  {isSmallScreen && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        size="small"
                        startIcon={<OpenInNewIcon />}
                        sx={{
                          color: "#0068d1",
                          backgroundColor: "#ebf5ff",
                          p: "5px 12px",
                        }}
                        onClick={() => window.open(project.link, "_blank")}
                      >
                        View Project
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <Button
          variant="outlined"
          size="large"
          startIcon={<GitHubIcon />}
          sx={{
            borderRadius: "60px",
            border: "2px solid #6E07F3",
            color: "#6E07F3",
            fontSize: "18px",
            marginTop: "2rem",
            padding: "10px 30px",
            "&:hover": {
              backgroundColor: "#6E07F3",
              color: "white",
              border: "2px solid #6E07F3",
            },
            textTransform: "none",
            fontFamily: "Font2",
          }}
          onClick={() =>
            window.open("https://github.com/K-u-n-a-l-c", "_blank")
          }
        >
          See More on GitHub
        </Button>
      </div>
    </section>
  );
}

export default Section4;
